export function autofocus(node: Node, options?: { selectAll?: boolean; ignore?: boolean }) {
	if (node.nodeType === Node.ELEMENT_NODE && !options?.ignore) {
		const element = node as HTMLElement;
		setTimeout(() => {
			const input = element.getElementsByTagName("input")[0];
			if (options?.selectAll) {
				input?.select();
			} else {
				input?.focus();
			}
		}, 0);
	}
}
